module.exports = "<div class=\"contai\">\n  <h1 style=\"color: red\">\n    404\n  </h1>\n  <h2>Sorry, page not found!</h2>\n</div>\n\n"